import React, { FC } from 'react';
import cn from 'classnames';
import { useLandingPageContext } from 'context/LandingPageContext';
import styles from './LPDesctiption.module.scss';

export interface LPDescriptionProps {
  description?: string;
  heading1?: string;
  heading2?: string;
  title?: string;
  cardsCount?: number;
  description1Preview?: string;
  description2?: string;
  description2Preview?: string;
}

const LPDescription: FC<LPDescriptionProps> = ({
  description,
  heading1,
  heading2,
  title,
  cardsCount,
  description1Preview,
  description2,
  description2Preview,
}) => {
  const { theme } = useLandingPageContext();
  return (
    <div className={cn(styles.container, styles[`theme-${theme}`])}>
      {heading2 && <h2 className={styles.heading2} dangerouslySetInnerHTML={{ __html: heading2 }} />}
      {heading1 && <h1 className={styles.heading1} dangerouslySetInnerHTML={{ __html: heading1 }} />}
      {(title || description1Preview || description || description2 || description2Preview) && (
        <div style={{ width: cardsCount && cardsCount > 1 ? '380px' : '100%' }}>
          {title && <h3 className={styles.heading3} dangerouslySetInnerHTML={{ __html: title }} />}
          {description1Preview ? (
            <p
              className={cn(styles.description, styles.smallerFont)}
              dangerouslySetInnerHTML={{ __html: description1Preview }}
            />
          ) : (
            description && (
              <p
                className={cn(styles.description, styles.largerFont)}
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )
          )}
          {description2Preview ? (
            <p className={styles.description} dangerouslySetInnerHTML={{ __html: description2Preview }} />
          ) : (
            description2 && <p className={styles.description} dangerouslySetInnerHTML={{ __html: description2 }} />
          )}
        </div>
      )}
    </div>
  );
};

export default LPDescription;
